import React from 'react'
import classes from './AboutPays.module.css'
import chart1 from '../../assets/img/chart1.svg'
import chart2 from '../../assets/img/chart2.svg'
import chart3 from '../../assets/img/chart3.svg'
import chart4 from '../../assets/img/chart4.svg'

export default function AboutPays() {
  return (
    <div className={`container ${classes.aboutPays}`}>
      <div className='row px-3 px-lg-0 pb-lg-5'>
      <div className='col-12 col-lg-6 d-flex justify-content-lg-center align-items-center mb-3 mb-lg-4'>
          <img
            src={chart1}
            alt='Vouchers'
            className={`${classes.chart}`}
          />
        </div>
        <div className='col-12 col-lg-6 d-flex justify-content-lg-center align-items-center my-4 mb-lg-4 mt-lg-0'>  
          <div className={classes.content}>
            <h2>Komplett digital und automatisiert</h2>
            <p>
            Lorem ipsum dolor sit amet consectetur. Mauris placerat lacus cras vel nulla eu tempus enim nulla. Morbi vitae sed sem imperdiet.
            </p>
          </div>
        </div>
      </div>
      <div className='row mx-3 mx-lg-0'>
      <div className='col-12 col-lg-6 d-flex justify-content-lg-center align-items-center mb-3 mb-lg-4 order-1 order-lg-2'>
          <img
            src={chart2}
            alt='Vouchers'
            className={`${classes.chart}`}
          />
        </div>
        <div className='col-12 col-lg-6 d-flex justify-content-lg-center align-items-center my-4 mb-lg-4 mt-lg-0 order-2 order-lg-1'>  
          <div className={classes.content}>
            <h2 className='fw-normal'>Verschiedenste Zahlungs- möglichkeiten</h2>
            <p>
            wie u.a. Kreditkarte, Klarna Rechnungskauf und Paypal. Lorem ipsum dolor sit amet consectetur. Mauris placerat lacus cras vel nulla eu tempus enim nulla. Morbi vitae sed sem imperdiet.
            </p>
          </div>
        </div>
      </div>
      <div className='row mx-3 mx-lg-0'>
      <div className='col-12 col-lg-6 d-flex justify-content-lg-center align-items-center mb-3 mb-lg-4'>
          <img
            src={chart3}
            alt='Vouchers'
            className={`${classes.chart}`}
          />
        </div>
        <div className='col-12 col-lg-6 d-flex justify-content-lg-center align-items-center my-4 mb-lg-4 mt-lg-0'>  
          <div className={classes.content}>
            <h2 className='fw-normal'>Zügiger Emailsupport bei Rückfragen</h2>
            <p>
            Lorem ipsum dolor sit amet consectetur. Mauris placerat lacus cras vel nulla eu tempus enim nulla. Morbi vitae sed sem imperdiet.
            </p>
          </div>
        </div>
      </div>
      <div className='row mx-3 mx-lg-0'>
      <div className='col-12 col-lg-6 d-flex justify-content-lg-center align-items-center mb-3 mb-lg-4 order-1 order-lg-2'>
          <img
            src={chart4}
            alt='Vouchers'
            className={`${classes.chart}`}
          />
        </div>
        <div className='col-12 col-lg-6 d-flex justify-content-lg-center align-items-center my-4 mb-lg-4 mt-lg-0 order-2 order-lg-1'>  
          <div className={classes.content}>
            <h2 className='fw-normal'>Deutscher Datenschutz</h2>
            <p>
            wie u.a. Kreditkarte, Klarna Rechnungskauf und Paypal. Lorem ipsum dolor sit amet consectetur. Mauris placerat lacus cras vel nulla eu tempus enim nulla. Morbi vitae sed sem imperdiet.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
